import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ExitActionDto } from "./exit-action.dto";

export class ExitActionResponseModel extends GlobalResponseObject{
    data?: ExitActionDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ExitActionDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}